import { useMemo } from 'react'
import { IMoreMenuItem } from '@sales-center/components'
import { useDialogState } from '@user/utils/useDialogState'
import { locationToFormModel } from '../../AddServiceLocationForm'
import { SmallLocationCardProps } from '../SmallLocationCard'
import {
  permissionDenied,
  useCheckPermissions,
} from '@user/store/authorization/permissions'
import { useSelector } from 'react-redux'
import {
  selectCurrentUser,
  updateLocationNoPermission,
  updateLocationUnmatched,
} from '@user/store/authorization'
import { ENTITY_TYPES } from '@sales-center/common'

export function useForm(params: SmallLocationCardProps, matched: boolean) {
  const { location, entityType } = params

  const [open, onOpen, onClose] = useDialogState()

  const [canUpdateLocations, canUpdateOpps, canUpdateLeads] =
    useCheckPermissions(
      'accounts_update',
      'opportunities_update',
      'leads_update',
    )

  const { externalUserId } = useSelector(selectCurrentUser)
  const canUpdateEntity =
    entityType === ENTITY_TYPES.Lead
      ? canUpdateLeads
      : canUpdateOpps || (matched && canUpdateLocations && externalUserId)
  const [initialValues, editMenuOption] = useMemo(() => {
    const formModel = locationToFormModel(location)

    const menuOption: IMoreMenuItem = {
      label: 'Edit',
      onClick: onOpen,
      disabled:
        !canUpdateEntity ||
        (matched && (!canUpdateLocations || !externalUserId)),
      tooltipText: !canUpdateEntity
        ? permissionDenied
        : matched
        ? !canUpdateLocations
          ? updateLocationNoPermission
          : !externalUserId
          ? updateLocationUnmatched
          : ''
        : '',
      dataTestId: 'editBillToOptionBtn',
    }

    return [formModel, menuOption] as const
  }, [
    canUpdateEntity,
    canUpdateLocations,
    externalUserId,
    location,
    matched,
    onOpen,
  ])

  return {
    editMenuOption,
    formProps: {
      open,
      onClose,
      initialValues,
    },
  }
}
